import { format as tzFormat, toZonedTime } from 'date-fns-tz'

let appTimezone: string | undefined

export function tz(timezone?: string) {
  if (!appTimezone && !timezone) {
    throw new Error('No timezone provided')
  }

  if (!appTimezone && timezone) {
    appTimezone = timezone
  }

  function datetime(timestamp: string) {
    return toZonedTime(timestamp, appTimezone!)
  }

  return {
    now: () => datetime(new Date().toISOString()),
    parse: (timestamp: string) => datetime(timestamp),
    format: (timestamp: string, format: string) =>
      tzFormat(datetime(timestamp), format, {
        timeZone: appTimezone,
      }),
  }
}
